
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView, initHubSpot } from '@/utils/trackingScripts';

/**
 * Component to track route changes for analytics
 * Place this in your App component to track all route changes
 */
export const RouteTracker = () => {
  const location = useLocation();
  
  useEffect(() => {
    // Update tracking when the route changes
    const currentPath = location.pathname + location.search;
    
    // Track page view in analytics platforms (now includes GTM)
    trackPageView(currentPath, document.title);
    
    // Reinitialize HubSpot tracking
    initHubSpot();
    
    // Log for debugging
    console.log('Route changed:', currentPath);
  }, [location]);
  
  // This component doesn't render anything
  return null;
};
